export const HEALTH_DATA_TYPE = {
  ALLERGY: 'ALLERGY',
  CONTINUOUS_MEDICINE: 'CONTINUOUS_MEDICINE',
  PREGNANCY: 'PREGNANCY'
}

export const HEALTH_DATA_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}

export const DEFAULT_ACTIVE_COLOR = 'blue'
export const DEFAULT_INACTIVE_COLOR = 'gray'
